module.exports = __webpack_public_path__ + "img/section5_img1_2.97a00274.svg";